import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

/**
 *  PresentationItem
 */
class PresentationItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    imageSrc: PropTypes.string,
    videoSrc: PropTypes.string,
    displayOnTop: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcDescription: null,
    mbDescription: null,
    imageSrc: null,
    videoSrc: null,
    displayOnTop: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  test() {
    //console.log(this.props.containerId);
  }
  
  render() {
    const {
      containerId,
      containerClass,
      pcDescription,
      mbDescription,
      imageSrc,
      videoSrc,
      displayOnTop,
    } = this.props;
    
    //
    const getPcDescription = () => {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return null;
      }
    };
    
    //
    const getMbDescription = () => {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };
    
    //
    const getDescription = () => {
      return (
        <div className="PresentationItem__description">
          <div className="PresentationItem__description-pc Wysiwyg"
               dangerouslySetInnerHTML={{__html: getPcDescription()}}
          />
          <div className="PresentationItem__description-mb Wysiwyg"
               dangerouslySetInnerHTML={{__html: getMbDescription()}}
          />
        </div>
      )
    };
    //
    const getMedia = () => {
      return (
        <div className="PresentationItem__media">
          {(() => {
            if (imageSrc) {
              return (
                <img
                  onLoad={handleImageLoaded.bind(this)}
                  className="PresentationItem__image"
                  src={imageSrc + "?t=" + new Date().getTime()}
                  alt=""
                />
              )
            }
            else if (videoSrc) {
              const attributes = {
                preload: 'none',
                controls: false,
                autoPlay: true,
                playsInline: true,
                muted: true,
                loop: true,
                src: videoSrc,
                poster: imageSrc,
                width: '100%',
              };
              return (
                <video {...attributes} />
              )
            } else {
              return (
                <img
                  onLoad={handleImageLoaded.bind(this)}
                  className="PresentationItem__image"
                  src={imageSrc + "?t=" + new Date().getTime()}
                  alt=""
                />
              )
            }
          })()}
        </div>
      )
    };
    
    const handleImageLoaded = (e) => {
      var elem = e.target;
      elem.style.maxWidth = elem.naturalWidth + 'px';
    };
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className="PresentationItem">
          {(() => {
            if (displayOnTop === true) {
              return (
                <div>
                  {getMedia()}
                  {getDescription()}
                </div>
              )
            } else {
              return (
                <div>
                  {getDescription()}
                  {getMedia()}
                </div>
              )
            }
          })()}
        </div>
      </Wrapper>
    )
  }
  
}

export default PresentationItem;



// WEBPACK FOOTER //
// ./src/containers/presentation-item/index.jsx